import { useAtomValue, useSetAtom } from 'infrastructure/state/jotai.wrapper'
import {
  filteredSourceFilesAtom,
  isBusyAtom,
  selectedSourceOptionAtom,
} from './atoms'
import React, { useState } from 'react'
import { useTransformSourceSelection } from './hooks'
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material'

export function SourceFile() {
  const files = useAtomValue(filteredSourceFilesAtom)
  const [selected, setSelected] = useState('')
  const setSource = useSetAtom(selectedSourceOptionAtom)

  if (!files?.length) return null

  const confirmSelect = async () => {
    if (!files) return
    const selectedOption = files.find(({ title }) => title === selected)
    setSource(selectedOption)
  }

  return (
    <Box display="flex">
      <Box width="180px">
        <FormControl fullWidth>
          <InputLabel id="select_file">Select Source File</InputLabel>
          <Select
            name="select_file"
            value={selected}
            onChange={({ target }) => setSelected(String(target.value))}
            label="Select Source File"
          >
            {files.map(({ title }) => {
              return (
                <MenuItem key={title} value={title}>
                  {title}
                </MenuItem>
              )
            })}
          </Select>
        </FormControl>
      </Box>
      <Button disabled={!selected} onClick={confirmSelect}>
        Select
      </Button>
      <GetNormalizedSourceForSelectedOption />
    </Box>
  )
}

function GetNormalizedSourceForSelectedOption() {
  const source = useAtomValue(selectedSourceOptionAtom)
  const retrieveFile = useTransformSourceSelection()
  const isBusy = useAtomValue(isBusyAtom)

  return (
    <Button loading={isBusy} onClick={retrieveFile} disabled={!source}>
      Retrieve
    </Button>
  )
}
